import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsBusfinderBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsBusfinderBlockEntity
